module.exports = __webpack_public_path__ + "static/media/coupon-delivery-disable.d4b37b40.png";